<template>
    <section class="about__area pb-50">
       <div class="container">
          <div class="row">
            <div class="col-xxl-6 col-xl-6 col-lg-6 pt-70">
                <div class="about__content pl-70">
                   <div class="section__title-wrapper mb-25">
                      <h2 class="section__title"><span class="yellow-bg-big">Ventas Consultivas<img src="../../assets/img/shape/yellow-bg-2.png" alt=""></span><br> para Servicios Logísticos</h2>
                      <p style="text-align: justify;">
                        Nuestro Semillero de Ventas Consultivas para Servicios Logísticos te equipa con las herramientas prácticas, estrategias innovadoras y habilidades críticas que necesitas para dominar las ventas en el competitivo mundo logístico.
                      </p>
                   </div>
                   <div class="about__list mb-35">
                      <ul>
                         <li class="d-flex align-items-center"> <span>&#10003;</span> Certificado de Asistencia por cada Módulo</li>
                         <li class="d-flex align-items-center"> <span>&#10003;</span> Examen de Habilidades Blandas al finalizar el programa</li>
                         <li class="d-flex align-items-center"> <span>&#10003;</span> Certificado de Cumplimiento Exitoso del Programa</li>
                         <li class="d-flex align-items-center"> <span>&#10003;</span> Informe Gerencial para bolsa de trabajo ADA y ASEACI </li>
                         <li class="d-flex align-items-center"> <span>&#10003;</span> Incluye: Clase presencial práctica de Role-play </li>
                      </ul>
                   </div>
                   <a class="e-btn e-btn-border" href="https://cursos.logigacorp.com/programa/semillero-ventas-consultivas" target="_blank">Ver programa</a>
                </div>
             </div>


             <div class="col-xxl-6  col-xl-6 col-lg-6 pb-70 pt-70">
                <div class="about__thumb-wrapper">
 
                   <div class="about__thumb text-center" style="font-size:34px;">
                      <!-- <span class="fecha_semillero page__title-pre hero__quote-animation" style="max-width: 530px;font-size: 34px!important;padding-top: 20px; background-color: #0F80C1; height:64px;">Inicio: 31 de Marzo del 2025 </span> -->
                      <img class="imagen_semillero" src="../../assets/img/about/portada_semillero_ventas_v1.jpg" alt="" style="max-width: 530px;">
                   </div>
                   <div class="about__banner mt--210">
                   </div>
                </div>
             </div>
          </div>
       </div>
    </section>
 </template>
 
 <script>
 export default {
    name:'ProgramaSemilleroVentasArea'
 };
 </script>
 
 <style>
    @media (min-width: 576px){
       .imagen_semillero{
          width:530px!important;
       }
       .fecha_semillero{
          width:530px!important;
          height:64px!important;
       }
    }
 
    @media (max-width: 576px){
       .fecha_semillero{
          height:114px!important;
       }
    }
 </style>
 